/**
 * Admin/LoginAsUser Controller
 *
 * 
 */

// the constructor for this object
function AdminLoginAsUserController() { }

// the object
AdminLoginAsUserController.prototype = {
    constructor: AdminLoginAsUserController,
    
    // initialize the controller
    init: function() 
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();
        
        // the user must be a USS admin to access this page
        PortalMain.ussAdminRedirect();
        
        PortalHelper.debugMessage('Login as User Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // turn on the submit button
        PortalHelper.enableButton('#login-button');
        
        PortalMain.AdminLoginAsUserController._showPage();
        
        PortalHelper.debugMessage('Login as User Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // handle the login
        $('#login-form').on('submit', function(e) {
            e.preventDefault();
            
            if($('#login-form').parsley().validate()) {
                
                var userEmail = $('#login-form #user-email').val();
                
                // disable login button while making request
                $(this).off('submit');
                PortalHelper.disableButton('#login-button');
                
                PortalMain.AdminLoginAsUserController._loginAsUser(userEmail);
                
            }
        });
    },
    
    // show the admin page
    _showPage: function()
    {
        var user = PortalMain.PortalToken.getPayload();
        if (user.uss_admin_level >= 3) {
            PortalHelper.loadingOverlay('.content-col__content', false);
        }
    },
    
    // retrieves the user we'll be logging in as
    _loginAsUser: function(userEmail)
    {
        var userRequest = new PortalRequest;
        userRequest.errorElement = '#login-form .form-errors';
        userRequest.makeRequest(
            '/admin/get-user-by-email',
            {
                email: userEmail,
            },
            function(data) {
                PortalMain.AdminLoginAsUserController._getUserToken(data.user_id);
            },
            function() {
                PortalMain.AdminLoginAsUserController._registerEvents();
                PortalHelper.enableButton('#login-button');
            }
        )
    },
    
    // sets up the portal to be logged in as the other user we provided
    _getUserToken: function(userId) 
    {
        var tokenRequest = new PortalRequest;
        tokenRequest.storeToken = true;
        tokenRequest.errorElement = '#login-form .form-errors';
        tokenRequest.makeRequest(
            '/admin/get-token-as-user',
            {
                userId: userId,
            },
            function(data, code, message) {
                PortalMain.LoginIndexController = new LoginIndexController;
                PortalMain.LoginIndexController.showSuccesfulLogin();
                PortalMain.LoginIndexController.loginComplete();
            },
            function() {
                PortalMain.AdminLoginAsUserController._registerEvents();
                PortalHelper.enableButton('#login-button');
            }
        );
    },

}